function getUtmParams(): string {
  try {
    // Only available on client side
    if (typeof window !== "undefined" && window.location?.search) {
      const urlParams = new URLSearchParams(window.location.search)
      const utmParams = new URLSearchParams()

      // Extract UTM and tracking parameters
      for (const [key, value] of urlParams) {
        if (
          key.includes("utm") ||
          key.includes("gclid") ||
          key.includes("fbclid") ||
          key.includes("gad_source") ||
          key.includes("creative") ||
          key.includes("audiences")
        ) {
          utmParams.append(key, value)
        }
      }

      return utmParams.toString()
    }
  } catch (error) {}

  return ""
}

export function appendUtmParams(url: string): string {
  const utmString = getUtmParams()
  if (!utmString) return url

  // Handle hash fragments correctly
  const hashIndex = url.indexOf("#")
  let baseUrl = url
  let hashFragment = ""

  if (hashIndex !== -1) {
    baseUrl = url.substring(0, hashIndex)
    hashFragment = url.substring(hashIndex)
  }

  const separator = baseUrl.includes("?") ? "&" : "?"
  return `${baseUrl}${separator}${utmString}${hashFragment}`
}
